import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b01cd14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapPage" }
const _hoisted_2 = { class: "backButton" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("＜ Back to Index")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapSpHeader" }, null, -1))
const _hoisted_5 = { class: "wrapBlog" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "createdAt" }
const _hoisted_8 = { class: "wrapTags" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BlogTag = _resolveComponent("BlogTag")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.$C.route.blog
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.postHeader.title), 1),
      _createElementVNode("p", _hoisted_7, "posted at " + _toDisplayString(_ctx.convertDate(_ctx.postHeader.created_at)), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_BlogTag, {
          tags: _ctx.postHeader.tags
        }, null, 8, ["tags"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_loading, {
          active: _ctx.loading,
          spinner: "bar-fade-scale"
        }, null, 8, ["active"])
      ]),
      (_ctx.postContent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "post",
            innerHTML: _ctx.postContent.bodyHtml.join('\n')
          }, null, 8, _hoisted_9))
        : _createCommentVNode("", true),
      _hoisted_10
    ])
  ]))
}